import { Col, Divider } from "@commonlibs";
import MainScaffold from "../MainScaffold/MainScaffold";
import { DashboardScaffoldProps } from "./DashboardScaffold.types";
import clsx from "clsx";

export default function DashboardScaffold({ children, className, ...rest }: DashboardScaffoldProps): JSX.Element {
    return (
        <Col className={clsx("dashboard-scaffold", className)} flex={1} {...rest}>
            {children[0] && (
                <Col>
                    {children[0]}
                    <Divider />
                </Col>
            )}
            <MainScaffold>{{ content: children[1] }}</MainScaffold>
        </Col>
    );
}
